import { BookOpen, LoaderCircle, Pin } from "lucide-react";
import type { Project, Session } from "../../api/types.js";
import type { FloatingPosition } from "./useFloatingMenu.js";
import { SessionMenu } from "./SessionMenu.js";
import { SessionTitleText } from "./SessionTitleText.js";

export function SessionList({
  sessions,
  projects,
  currentSession,
  activeRunSessionId = null,
  openSessionMenuId,
  sessionMenuPosition,
  openProjectSubmenuId,
  projectSubmenuPosition,
  openSessionMenu,
  closeSessionMenu,
  closeProjectMenu,
  openProjectSubmenu,
  closeProjectSubmenu,
  onOpenSession,
  onRenameSession,
  onMoveSession,
  onTogglePinSession,
  onDeleteSession
}: {
  sessions: Session[];
  projects: Project[];
  currentSession: Session | null;
  activeRunSessionId?: string | null;
  openSessionMenuId: string | null;
  sessionMenuPosition: FloatingPosition | null;
  openProjectSubmenuId: string | null;
  projectSubmenuPosition: FloatingPosition | null;
  openSessionMenu: (sessionId: string, rect: DOMRect, width: number, height: number) => void;
  closeSessionMenu: () => void;
  closeProjectMenu: () => void;
  openProjectSubmenu: (sessionId: string, rect: DOMRect, width: number, height: number) => void;
  closeProjectSubmenu: () => void;
  onOpenSession: (session: Session) => void;
  onRenameSession: (session: Session) => void;
  onMoveSession: (session: Session, projectId: string | null) => void;
  onTogglePinSession: (session: Session) => void;
  onDeleteSession: (session: Session) => void;
}) {
  return (
    <section className="sidebar-group sidebar-history" aria-label="历史对话">
      <div className="history-heading"><span>最近</span></div>
      <div className="history-list">
        {sessions.length === 0 && <p>暂无最近对话</p>}
        {sessions.map((session) => {
          const active = session.id === currentSession?.id;
          const menuOpen = openSessionMenuId === session.id;
          return (
            <div key={session.id} className={`history-row ${active ? "active" : ""} ${menuOpen ? "menu-open" : ""}`} data-session-menu-root>
              <button className="history-item history-row-main" type="button" aria-label={session.title} onClick={() => { closeSessionMenu(); onOpenSession(session); }}>
                <BookOpen size={16} />
                <SessionTitleText title={session.title} source={session.titleSource} />
                {session.id === activeRunSessionId && (
                  <LoaderCircle className="active-run-indicator" size={13} aria-label="正在处理" data-active-run-indicator />
                )}
                {session.pinnedAt && <Pin className="history-pin-indicator" size={13} aria-label="已置顶" />}
              </button>
              <SessionMenu
                session={session}
                projects={projects}
                menuOpen={menuOpen}
                menuPosition={sessionMenuPosition}
                projectSubmenuOpen={openProjectSubmenuId === session.id}
                projectSubmenuPosition={projectSubmenuPosition}
                openSessionMenu={openSessionMenu}
                closeSessionMenu={closeSessionMenu}
                closeProjectMenu={closeProjectMenu}
                openProjectSubmenu={openProjectSubmenu}
                closeProjectSubmenu={closeProjectSubmenu}
                onRenameSession={onRenameSession}
                onMoveSession={onMoveSession}
                onTogglePinSession={onTogglePinSession}
                onDeleteSession={onDeleteSession}
              />
            </div>
          );
        })}
      </div>
    </section>
  );
}
